import React, { useEffect, useState } from 'react';
import { Locale } from '../../pages/Locale/Locale';
import dayjs from 'dayjs';
import { CheckoutCalendarModal } from "../../pages";
import { getCalculationPickAndTotalAmount, handleErrorResponse, serviceIdVendorDetails } from '../../services';
import moment from 'moment-timezone';
const CheckoutCalendarModalLogic = ({ setApiCalculationData, calendarFormValue, setCalendarFormValue, isModalVisible, handleCancel, selectServiceDetails }) => {
    const { t } = Locale();
    const [selectedDate, setSelectedDate] = useState();
    const [selectedTimeSlot, setSelectedTimeSlot] = useState();
    const [showAtLocation, setShowLocation] = useState();
    const [showBranch, setShowBranch] = useState();
    const [options, setOptions] = useState([]);
    const [branchOptions, setBranchOptions] = useState([])
    const [timeSlots, setTimeSlots] = useState([]);
    const [vendorDetails, setVendorDetails] = useState();
    const [disableConfirmBtn, setDisableConfirmBtn] = useState(false);
    const [vendorOpeningHours, setVendorOpeningHours] = useState({
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
    });

    useEffect(() => {
        getVendorData();
        setShowLocation(calendarFormValue?.[selectServiceDetails?.service_id]?.atServiceLocation)
        setShowBranch(calendarFormValue?.[selectServiceDetails?.service_id]?.branch)
    }, [selectServiceDetails?.service_id, isModalVisible]);


    const generateTimeSlots = (date, vender_details) => {
        // Ensure date is always a valid Day.js object
        const parsedDate = dayjs(date, "DD/MM/YYYY", true).isValid()
            ? dayjs(date, "DD/MM/YYYY")
            : dayjs(date);

        const dayName = parsedDate.format('dddd');
        const selectedDayName = dayName.toLowerCase();
        const dayDetails = vender_details?.vendor_bussiness_hours?.[selectedDayName];

        const intervalMinutes = (vender_details?.service?.category?.name === 'Dental Clinics') ? 45 : 15;

        if (!dayDetails || dayDetails.shop_open === "false") {
            setTimeSlots([]);
            setDisableConfirmBtn(true);
            setSelectedTimeSlot(null);
            return [];
        }

        const openTime = dayDetails.open;  // e.g., "09:00"
        const closeTime = dayDetails.close; // e.g., "20:00"

        const timeSlots = [];
        const currentTime = moment(openTime, 'HH:mm');
        const endTime = moment(closeTime, 'HH:mm');
        const now = moment();
        const momentDate = moment(parsedDate.toDate());
        const isToday = momentDate.isSame(now, 'day');

        const breakStart = moment(vender_details?.break_time.start_time, 'HH:mm');
        const breakEnd = moment(vender_details?.break_time?.end_time, 'HH:mm');

        // Block times
        const selectedDateStr = parsedDate.format('DD/MM/YYYY');
        const blockedRanges = vender_details?.block_time?.length && vender_details?.block_time
            .filter(block => block.date === selectedDateStr)
            .map(block => ({
                start: moment(block.start_time, 'HH:mm'),
                end: moment(block.end_time, 'HH:mm')
            }));

        // Slot loop
        while (currentTime.isBefore(endTime)) {
            const slotStart = moment(currentTime);
            const slotEnd = moment(currentTime).add(intervalMinutes, 'minutes');

            const isFutureSlot = !isToday || slotStart.isSameOrAfter(now, 'minute');
            const isInBreak = slotStart.isBefore(breakEnd) && slotEnd.isAfter(breakStart);
            const isInBlocked = blockedRanges && blockedRanges?.some(block =>
                slotStart.isBefore(block.end) && slotEnd.isAfter(block.start)
            );

            if (isFutureSlot && !isInBreak && !isInBlocked) {
                timeSlots.push(slotStart.format('HH:mm'));
            }

            currentTime.add(intervalMinutes, 'minutes');
        }

        const bookingTime = calendarFormValue?.[selectServiceDetails?.service_id]?.booking_time;
        const isAvailableBookingTimeInSlots = timeSlots.includes(bookingTime);

        setDisableConfirmBtn(!isAvailableBookingTimeInSlots);
        setTimeSlots(timeSlots);
        setSelectedTimeSlot(bookingTime);
    };

    const getVendorData = async () => {
        try {
            const response = await serviceIdVendorDetails(selectServiceDetails?.service_id);
            setLocationOption(response?.data);
            setBusinessHourseFun(response?.data);
            setBranchOptionsFun(response?.data)
            setVendorDetails(response?.data);
            generateTimeSlots(calendarFormValue?.[selectServiceDetails?.service_id]?.booking_date, response?.data)
        }
        catch (err) {
            handleErrorResponse(err)
        }
    }

    const setLocationOption = (response) => {
        const options = [];
        if ((response?.service_at_customer_location)) {
            options.push({ value: 'at_my_location', label: t('field.atHome') });
        }
        if ((response?.service_at_bussiness_location)) {
            options.push({ value: 'at_shop', label: t('field.atShop') });
        }
        setOptions(options);
    };

    const setBusinessHourseFun = (response) => {
        if (response?.vendor_bussiness_hours) {
            const businessHours = response?.vendor_bussiness_hours;
            setVendorOpeningHours({
                monday: businessHours.monday?.shop_open === 'true',
                tuesday: businessHours.tuesday?.shop_open === 'true',
                wednesday: businessHours.wednesday?.shop_open === 'true',
                thursday: businessHours.thursday?.shop_open === 'true',
                friday: businessHours.friday?.shop_open === 'true',
                saturday: businessHours.saturday?.shop_open === 'true',
                sunday: businessHours.sunday?.shop_open === 'true',
            });
        } else {
            setVendorOpeningHours({
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                sunday: false,
            });
        }
    }

    const setBranchOptionsFun = (response) => {
        let tempOption = [{ value: null, label: selectServiceDetails?.shop_name }];
        const serviceBranchDetails = response?.service?.branch_details
        if (serviceBranchDetails) {
            serviceBranchDetails?.map((obj) => (
                tempOption.push({ value: obj?.id, label: obj?.name })))
        }
        setBranchOptions(tempOption);
    }

    const disabledDate = (current) => {
        if (current < moment().startOf('day')) {
            return true;
        }
        const dayName = current.format('dddd').toLowerCase();
        return !vendorOpeningHours[dayName];
    };

    const handleSubmit = async (event) => {
        const booking_date = selectedDate?.format('DD/MM/YYYY') || calendarFormValue?.[selectServiceDetails?.service_id]?.booking_date;
        const booking_time = selectedTimeSlot;
        setCalendarFormValue((prev) => ({
            ...prev,
            [selectServiceDetails?.service_id]: {
                ...prev[selectServiceDetails?.service_id],
                atServiceLocation: showAtLocation,
            }
        }));

        await setCalendarFormValue((prev) => ({
            ...prev,
            [selectServiceDetails?.service_id]: {
                ...prev[selectServiceDetails?.service_id],
                booking_date,
                booking_time,
            }
        }));

        await getCalculationData(booking_date, booking_time)
        await handleCancel()
    }

    const getCalculationData = async (booking_date, booking_time) => {
        try {
            const booking_service_details = Object.keys(calendarFormValue).map(service_id => {
                if (service_id === selectServiceDetails?.service_id) {
                    return {
                        service_id: selectServiceDetails?.service_id,
                        booking_date: booking_date,
                        booking_time: booking_time,
                        branch_id: calendarFormValue[service_id]?.branch?.branch_id
                    };
                } else {
                    return {
                        service_id: parseInt(service_id),
                        booking_date: calendarFormValue[service_id]?.booking_date,
                        booking_time: calendarFormValue[service_id]?.booking_time,
                        branch_id: calendarFormValue[service_id]?.branch?.branch_id
                    };
                }
            });

            let param = { booking_service_details };
            let response = await getCalculationPickAndTotalAmount(param);
            setApiCalculationData(response?.data?.booking);
            setCalendarFormValue((prev) => ({
                ...prev,
                [selectServiceDetails?.service_id]: {
                    ...prev[selectServiceDetails?.service_id],
                    atServiceLocation: showAtLocation,
                    branch: {
                        branch_id: showBranch?.branch_id,
                        branch_name: showBranch?.branch_name,
                    },
                    booking_date,
                    booking_time,
                }
            }));
            handleCancel();
        }
        catch (err) {
            handleErrorResponse(err)
        }
    }


    const handleLocationChange = (id, value) => {
        setShowLocation(value)
    }

    const handleBranchChange = (id, value) => {
        setShowBranch({
            branch_id: id,
            branch_name: value?.label
        })
    }

    const handleDateChange = (date) => {
        setSelectedDate(date);
        generateTimeSlots(date, vendorDetails)
    };

    const handleTimeSlotClick = (slot) => {
        setDisableConfirmBtn(false)
        setSelectedTimeSlot(slot)
    }

    return <>
        <CheckoutCalendarModal
            disableConfirmBtn={disableConfirmBtn}
            showBranch={showBranch}
            showAtLocation={showAtLocation}
            isModalVisible={isModalVisible}
            handleCancel={handleCancel}
            selectServiceDetails={selectServiceDetails}
            handleOk={handleSubmit}
            handleLocationChange={handleLocationChange}
            disabledDate={disabledDate}
            uniqueId={`date-popup-${selectServiceDetails?.service_id}-${performance.now()}`}
            options={options}
            selectedDate={selectedDate}
            selectedTimeSlot={selectedTimeSlot}
            onDateChange={handleDateChange}
            calendarFormValue={calendarFormValue}
            handleBranchChange={handleBranchChange}
            branchOptions={branchOptions}
            handleTimeSlotClick={handleTimeSlotClick}
            timeSlots={timeSlots}
        />
    </>
}

export default CheckoutCalendarModalLogic;